import classnames from 'classnames';
import Text from 'src/components/Text';
import ContentLayout from 'src/layouts/ContentLayout';

import { styles } from './styles';

export interface ErrorListType {
  className?: string;
  image?: string;
  title?: string;
  subtitle?: string;
}

function ErrorList({
  className,
  image,
  title,
  subtitle,
}: Readonly<ErrorListType>) {
  const { classes } = styles();
  return (
    <ContentLayout hasBackground fullContainer>
      <div className={classnames(classes.container, className)} data-testid={'error-list'}>
        {image && <img src={image} alt="Error"/>}
        {title && (
          <Text variant="Caption-Regular">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text variant="Body-Regular">
            {subtitle}
          </Text>
        )}
      </div>
    </ContentLayout>
  );
}

export default ErrorList;
